export const GET_DEFAULT_WHATSAPP_TEMPLATES = "notifications/wa/templates/list";
export const GET_CUSTOM_WHATSAPP_TEMPLATES =
  "notifications/wa/templates/custom/list";
export const CREATE_WHATSAPP_CAMPAIGN =
  "notifications/whatsapp/campaign/create";
export const GET_WHATSAPP_TEMPLATE_CATEGORIS =
  "notifications/wa/categories/list";
